module.exports = __webpack_public_path__ + "static/media/grayFourSquaresIcon.28cfbd0e.svg";